export const SET_UNSAVED_CHANGES = "SET_UNSAVED_CHANGES";
export const SET_VISIT_LOCK = "SET_VISIT_LOCK";

export const setUnsavedChanges = (unsavedChanges) => {
    return {
        type: SET_UNSAVED_CHANGES,
        unsavedChanges
    };
};

export const setVisitLock = (visit, isVisitLocked) => {

    return {
        type: SET_VISIT_LOCK,
        selectedVisit: {
            isVisitLocked: isVisitLocked,
            reportId: visit === null ? null : visit.reportId
        }
    };
};